import React from 'react';
import styled from 'styled-components';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores';
import {LabelForm } from '../componentes_generales/componentes_formulario/labels';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { connect } from 'react-redux';
import SelectArticulo from '../inventario/selectArticulo';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cargarCatalogosAsync,cargarCatalogosBodega} from '../../funciones_globales/catalogos';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
const COD_ACCESO_TOMA_CREACION = '021201';
const PaginationLabels = styled.div`
    font-size: 12px;
`;
const LabelTotales = styled.label`
	display: inline-block;
	font-size: 10px;
	color: green;
`;
const LabelValorTotales = styled.label`
	display: inline-block;
	font-size: 9px;
	font-weight: bold;
	align-text: right;
`;
const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;
const LabelTipoProf = styled.label`
  display: inline;
  font-size: 10px;
  color: green;    
`;
const ModalContainer = styled.div`
	margin-top: 30px;
	height: 200px;
	width: 700px;
`;
const Hr = styled.hr`
	margin-top: 10px;
	margin-bottom: 10px;
`;

class FormInven12 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {
      puedeGuardar:true,
      bodegasCreacion_sel:[],
      bodegasCreacion:[],
      idTomaSeleccionada:null,
      tomaInventarioBusqueda:'',
      isVisibleModalDetalleTomaInventario:false,
      isVisibleBotonCreacionToma:false,
      detalleTomaInventario:[],
      totalDetalleToma:0,  
      lineas:[],
      tomasInventario:[],
      toma_inventario_seleccionada:null,
      linea_seleccionada:null,
      usuario:'',
      articulo_seleccionado:null,
      tipo_toma:'',
      muestra_stock:'N',
      bodega_sel: null,
      bodega_opt: [],
      numero_de_parte:'',
      articulos:[],
      verTodos:true,
      MuestraStock:true,
      isVisibleModalTomaInventario:false,
      articulosArrayAux:[],
      articulosTomaArrayCorte:[],
      tipo_toma_array_seleccionada:null,
      observacion_toma:'',
      TipoTomaArray:[{
        value:'L',
        label:'Stock en Linea'
      },
      {
        value:'C',
        label:'Stock a una fecha Corte'
      }],
      columnDefs :[ 
        {   header: "Código",
            field: "Codigo",
            width: 70,
            type: "string",
        },
        {   header: "Cód. Parte",
            field: "Codigo_Parte",
            width: 80,
            type: "string"
        },
        {
            header: "Artículo",
            field: "Nombre",
            width: 140,
            type: "string"
        },
        {
          header: "Unidad",
          field: "Unidad",
          width: 65,
          type: "string"
        },
        {
            header: "Ubicación",
            field: "Ubicacion",
            width: 80,
            type: "string", 
        },
        {
          header: "Cant.Toma",
          field: "Cantidad_Toma",
          width: 85,
          type: "num_entero",
          editable:true
        },
        {
            header: "Cant.Toma.Acu",
            field: "Cantidad_Acumulada",
            width: 105,
            type: "num_entero",
        },
        {
            header: "Stock",
            field: "Stock",
            width: 60,
            type: "num_entero"
        },
        {
            header: "Reserva.",
            field: "Reserva",
            width: 75,
            type: "num_entero"
        },
        {
            header: "Dev.NoProcesada",
            field: "Cantidad_Devoluciones",
            width: 112,
            type: "num_entero"
        }
      ],
      columDTomaInventario:[
        {   header: "Artículo",
            field: "Articulo",
            width: 200,
            type: "string",
        },
        {   header: "Cantidad",
            field: "Cantidad",
            width: 80,
            type: "string"
        }
      ],
       pagination: {
          totalFilas: 0,
          totalFilasPorPagina: 0,
          primaraFilaPagina: 0,
          ultimaFilaPagina: 0,
      }, 
      paginationDetalleToma: {
        totalFilas: 0,
        totalFilasPorPagina: 0,
        primaraFilaPagina: 0,
        ultimaFilaPagina: 0,
    }, 
    };

    this.gridOptions = {
        enableColResize: true,
        enableSorting: true,
        enableFilter: true,
        rowSelection: "single",
        suppressScrollOnNewData: true,
        paginationAutoPageSize:true,
        pagination: true,
        suppressPaginationPanel: true,
        onRowDataChanged: ((event)=>{
        }),
        onCellValueChanged:((event)=>{   
          var indice=event.node.id;
          var articulos = this.state.articulos;
            if(event.colDef.field==="Cantidad_Toma"){
                let totalAcumuladoYCantidad= parseInt(event.data.Cantidad_Toma,10)+ parseInt(event.data.Cantidad_Acumulada,10);
                if(totalAcumuladoYCantidad>parseInt(event.data.Stock,10) && this.state.tipo_toma==='L'){ //solo si es tipo linea mandara un mensaje pero igual dejara ingresar
                    alert('Advertencia: La cantidad Ingresada es mayor que el stock')
                  }
                  var sendData={};
                  sendData.bodega= this.state.bodega_sel;
                  sendData.tomaInventario= this.state.toma_inventario_seleccionada;
                  sendData.articulo= event.data.Codigo;
                  sendData.stock= event.data.Stock;
                  sendData.reserva= event.data.Reserva;
                  sendData.cantidad= parseInt(event.data.Cantidad_Toma,10);
                  sendData.usuario= this.state.usuario;
                  sendData.tipo_toma= this.state.tipo_toma
                  console.log("DATA A GUARDAR")
                  console.log(sendData)
                  global_axios({
                    method: 'POST',
                    url: '/tomainventario/guardar_toma_inventario',
                    data: sendData
                  }).then((response)=>{
                      let art= response.data.datos[0];
                      articulos[indice].Cantidad_Toma= 0;
                      articulos[indice].Cantidad_Acumulada= art.Cantidad_Acumulada; 
                      this.setState({articulosArrayAux: this.state.articulos,articulosTomaArrayCorte:this.state.articulos, verTodos:false})
                      this.mostrarArticulosStockMenorAcumulado();
                      this.api.refreshCells();
                  })
                  .catch((err)=>{
                      console.log(err)
                      this.props.cambiar_VisualizacionLoading(false);
                      alert('No se pudo procesar la transacción...');
                  });
                
            }
            this.api.refreshCells();
        }),
      onPaginationChanged: () => {
        if(!this.api){
            return;
        }
        let totalFilas = this.api.paginationGetRowCount();
        let totalFilasPorPagina = this.api.paginationGetPageSize();
        let ultimaFilaPagina = (totalFilasPorPagina * (this.api.paginationGetCurrentPage()+1));
        let indexPage = this.api.paginationGetCurrentPage();

        if( ultimaFilaPagina >  totalFilas){
            ultimaFilaPagina = totalFilas;
        }
   
        let pagination = {
            totalFilas: totalFilas,
            totalFilasPorPagina: totalFilasPorPagina,
            primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
            ultimaFilaPagina: ultimaFilaPagina
        };
       
        this.setState({pagination});
      },
    };
    this.gridDetalleTomaOptions = {
      rowSelection: 'single',
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,

      /* Se podrá importar pedidos moviles o pedidos de devolución por garantía */
      onRowDoubleClicked: (event)=>{
      },
      onPaginationChanged: () => {
        if(!this.apiDetalleToma){
            return;
        }
        let totalFilas = this.apiDetalleToma.paginationGetRowCount();
        let totalFilasPorPagina = this.apiDetalleToma.paginationGetPageSize();
        let ultimaFilaPagina = (totalFilasPorPagina * (this.apiDetalleToma.paginationGetCurrentPage()+1));
        let indexPage = this.apiDetalleToma.paginationGetCurrentPage();

        if( ultimaFilaPagina >  totalFilas){
            ultimaFilaPagina = totalFilas;
        }
   
        let pagination = {
            totalFilas: totalFilas,
            totalFilasPorPagina: totalFilasPorPagina,
            primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
            ultimaFilaPagina: ultimaFilaPagina
        };
       
        this.setState({paginationDetalleToma:pagination});
      },
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.onGridDetalleTomaReady = this.onGridDetalleTomaReady.bind(this);   
    this.submit = this.submit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.buscarStockArticulos = this.buscarStockArticulos.bind(this);
    this.immutablePush = this.immutablePush.bind(this);
    this.getOptions_TiposCompra = this.getOptions_TiposCompra.bind(this);
    this.cargarTomasInventario = this.cargarTomasInventario.bind(this);
    this.actualizarColumnas= this.actualizarColumnas.bind(this);
    this.limpiar= this.limpiar.bind(this);
    this.verTodos = this.verTodos.bind(this);
    this.crearToma = this.crearToma.bind(this);
    this.mostrarArticulosStockMenorAcumulado = this.mostrarArticulosStockMenorAcumulado.bind(this);
    this.abrirModalTomaInventario = this.abrirModalTomaInventario.bind(this);
    this.cargarTomasInventarioNueva = this.cargarTomasInventarioNueva.bind(this);
    this.detalleTomaInventario = this.detalleTomaInventario.bind(this);
    this.cargarDetalleTomaInventarioArticulo=this.cargarDetalleTomaInventarioArticulo.bind(this)
    this.cambiarBodega= this.cambiarBodega.bind(this)
    this.getTomaById = this.getTomaById.bind(this)
    this.setBodegasCreacion = this.setBodegasCreacion.bind(this)
    this.cargarBodegasTomaInventario= this.cargarBodegasTomaInventario.bind(this);
    this.anularToma = this.anularToma.bind(this)
  }
  getTomaById(){
    if(this.state.tomaInventarioBusqueda !==''){
        global_axios({
          method: 'GET',
          url: 'tomainventario/cargar_toma_por_id?idToma='+this.state.tomaInventarioBusqueda
        })
        .then((response)=> {  
           if(response.data!==null){
              this.setState({tipo_toma_array_seleccionada:response.data.TipoToma,
                MuestraStock:(response.data.MuestraStock==='N')?false:true,
                observacion_toma:response.data.Observacion,
                idTomaSeleccionada:response.data.TomaInventarioId,
                bodegasCreacion_sel:response.data.detTomaBodegas,
                puedeGuardar:false,
            })
           }else{
             alert('La Toma De Inventario NO existe o se encuentra Anulada.')
           }
        })
        .catch((error) => {
          if (error.response){
            alert(error.response.data.msg);         
          }else{
            alert(error.message);
          }
        });   
    }else{
      alert("Debe ingresar un numero de Toma de Inventario para continuar...")
    }
  }
  cambiarBodega(value){
    this.setState({bodega_sel: value!==null?value.value:null, articulos:[],articulosArrayAux:[], articulosTomaArrayCorte:[], verTodos:true}); 
    if(value===null){
      this.limpiar()
    }
  } 
  verTodos(event){
    if(this.state.articulos.length>0){
      this.setState({ verTodos: !this.state.verTodos},()=>{
        if(this.state.verTodos){
          if(this.state.tipo_toma==='C'){
            this.setState({articulos:this.state.articulosArrayAux})
          }else{
            let query = "?bodega="+this.state.bodega_sel+"&tomaInventario="+ this.state.toma_inventario_seleccionada +"&linea=" + this.state.linea_seleccionada+"&articulo="+ this.state.articulo_seleccionado+"&numero_parte="+ this.state.numero_de_parte;   
            if(this.state.toma_inventario_seleccionada!==null){
                if(this.state.bodega_sel!==null){
                  global_axios({
                      method: 'GET',
                      url: 'stocks/cargar_inventario_toma'+query
                    })
                    .then((response)=> {  
                      this.setState({articulos:response.data.datos, articulosArrayAux:response.data.datos})
                    })
                    .catch((error) => {
                      if (error.response){
                        alert(error.response.data.msg);         
                      }else{
                        alert(error.message);
                      }
                    });   
                }else{
                    alert("Seleccione una Bodega para continuar...")
                }
            }else{
              alert("Seleccione una Toma de Inventario para continuar...")
            }
          }
        }else{
          this.mostrarArticulosStockMenorAcumulado();
        }
      })
    }else{
      alert("Deber cargar Artículos para poder filtrar")
    }
    
  }
  limpiar(){
    this.setState({toma_inventario_seleccionada:null,bodega_sel:null,linea_seleccionada:null,
      articulo_seleccionado:null,numero_de_parte:'', articulos:[], articulosArrayAux:[],articulosTomaArrayCorte:[],
       verTodos:true,tipo_toma_array_seleccionada:null,MuestraStock:true,observacion_toma:'', idTomaSeleccionada:null});
  
  } 
  detalleTomaInventario(){
   
    let filaSeleccionada = this.api.getSelectedRows();
    if (filaSeleccionada[0]===undefined){
      alert('Debe seleccionar una fila para poder ver su detalle.')
      return;
    }
    this.cargarDetalleTomaInventarioArticulo(filaSeleccionada[0])
    this.setState({isVisibleModalDetalleTomaInventario:true})
  }
  cargarDetalleTomaInventarioArticulo(fila){
    this.props.cambiar_VisualizacionLoading(true);
    let query = "?bodega="+this.state.bodega_sel+"&tomaInventario="+ this.state.toma_inventario_seleccionada +"&articulo=" + fila.Codigo;  
    global_axios(
      { method: 'GET',
        url: 'tomainventario/cargar_detalle_tomas_inventario_articulo'+query,
      }
    )
    .then((response)=>{
      let articulos= response.data.datos;
      let total= 0;
      for(let i=0; i < articulos.length; i++){
          total= total+parseInt(articulos[i].Cantidad,0);
      }
      this.setState({detalleTomaInventario:articulos, totalDetalleToma: total})
      this.props.cambiar_VisualizacionLoading(false);
    })
    .catch((err)=>{
      console.log(err)
        this.props.cambiar_VisualizacionLoading(false);
        alert('No se pudo procesar la transacción...');
    });
  }
  mostrarArticulosStockMenorAcumulado(){
    //Se procede a recorrer el arreglo de articulos para preguntar cuales tienen stock menor al valor acumulado, de esta manera se mostraran solo los que tengan el stock menor.
   let articulos=[];
    for(let i =0 ; i< this.state.articulos.length; i++){
      if(parseInt(this.state.articulos[i].Stock,10)>parseInt(this.state.articulos[i].Cantidad_Acumulada,10)){
        articulos.push(this.state.articulos[i])
      }
   }
   this.setState({articulos})
  }
  getOptions_TiposCompra(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('TIPOPRECIO', input, callback)
    }
  }  
  cargarTomasInventario(){
      return new Promise((resolve, reject) => {
        global_axios(
          { method: 'GET',
            url: 'tomainventario/cargar_tomas_inventario/',
          }
        )
        .then((response)=>{
              resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})`, muestra_stock:item.MuestraStock ,tipo_toma:item.TipoToma })));
          })
          .catch((err)=>{
            alert('No se pudo obtener Tomas de Inventario...');
          });
      });
  }
  submit(e){
    e.preventDefault();
    if(this.state.cuentasContablesDepartamento.length>0){
      
          var sendData= {};
          sendData.PlanCuenta=this.state.planVigente[0].value;
          sendData.Departamento= this.state.departamento_seleccionado.value;
          sendData.cuentasContablesDepartamento= this.state.cuentasContablesDepartamento;
          global_axios(
            { method: 'POST',
              url: '/accesocuentadepartamento/',
              data: sendData
            }
          )
          .then(()=>{
            this.cargarCuentasDepartamento();
            alert('Transacción procesada con exito')
          })
          .catch((err)=>{
            console.log(err)
              this.props.cambiar_VisualizacionLoading(false);
              alert('No se pudo procesar la transacción...');
          });
      }else{
        alert("Ingrese cuentas para proceder...")
      } 
     
  }
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }
  onGridDetalleTomaReady(params) {
    this.apiDetalleToma = params.api;
    this.columnApiDetalleToma = params.columnApi;
  }
  componentDidMount() {
    let usuario = getItemDatosSesion('usuario');
    Promise.all([
        getItemDatosSesion('usuario'),
        cargarCatalogosBodega('BODEGA'), 
        this.cargarTomasInventario(),  
        cargarPermisoBoton(COD_ACCESO_TOMA_CREACION, usuario),
        this.props.generar_LogAuditoriaIngresoForm('0212'), 
    ])
    .then(([usuario,bodegasCreacion,tomasInventario,isVisibleBotonCreacionTomaEntrada]) => {
      let isVisibleBotonCreacionToma = false;
      if(isVisibleBotonCreacionTomaEntrada.display==='block'){
        isVisibleBotonCreacionToma = true;
      }
      this.setState(
        {
          usuario,bodegasCreacion,tomasInventario,isVisibleBotonCreacionToma
        }) 
    })
    .catch(err => {
      console.log(err);
    });        
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0212');
  } 
  

  immutablePush(array, newItem){
    return [ ...array, newItem ];  
  }
  buscarStockArticulos(){
    let query = "?bodega="+this.state.bodega_sel+"&tomaInventario="+ this.state.toma_inventario_seleccionada +"&linea=" + this.state.linea_seleccionada+"&articulo="+ this.state.articulo_seleccionado+"&numero_parte="+ this.state.numero_de_parte+"&tipo="+ this.state.tipo_toma;   
    if(this.state.toma_inventario_seleccionada!==null){
        if(this.state.bodega_sel!==null){
          this.props.cambiar_VisualizacionLoading(true);
          global_axios({
              method: 'GET',
              url: 'stocks/cargar_inventario_toma'+query
            })
            .then((response)=> {  
              this.setState({articulos:response.data.datos, articulosArrayAux:response.data.datos, articulosTomaArrayCorte:response.data.datos})
              this.props.cambiar_VisualizacionLoading(false);
            })
            .catch((error) => {
              this.props.cambiar_VisualizacionLoading(false);
              if (error.response){
                alert(error.response.data.msg);         
              }else{
                alert(error.message);
              }
            });   
        }else{
            alert("Seleccione una Bodega para continuar...")
        }
    }else{
      alert("Seleccione una Toma de Inventario para continuar...")
    }
    
  
  }
  setBodegasCreacion( value){
    this.setState({bodegasCreacion_sel:value})
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  changeCuentaAdd(value){
    this.setState({cuenta_seleccionada: value})
  }
  abrirModalTomaInventario(){
    this.setState({isVisibleModalTomaInventario:true})
  }
  cargarTomasInventarioNueva(){
    global_axios(
      { method: 'GET',
        url: 'tomainventario/cargar_tomas_inventario/',
      }
    )
    .then((response)=>{
          let  tomas = response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})`, muestra_stock:item.MuestraStock ,tipo_toma:item.TipoToma }));
          this.setState({tomasInventario:tomas})
        })
      .catch((err)=>{
        alert('No se pudo obtener Tomas de Inventario...');
      });
  }
  cargarBodegasTomaInventario(){
    let query = "?tomaInventarioId="+this.state.toma_inventario_seleccionada;   
    global_axios(
      { method: 'GET',
        url: 'tomainventario/cargar_bodegas_toma_inventario/'+ query,
      }
    )
    .then((response)=>{
          let  bodegas = response.data.bodegasFinales.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})`}));
          this.setState({bodega_opt:bodegas})
        })
      .catch((err)=>{
        alert('No se pudo obtener las bodegas de la Toma de Inventario...');
      });
  }
  anularToma(){
    if(this.state.idTomaSeleccionada!==null){
      //Puese anular 
      let sendData={};
      sendData.TomaInventarioId = this.state.idTomaSeleccionada;
      this.props.cambiar_VisualizacionLoading(true);
      global_axios({
        method: 'POST',
        url: '/tomainventario/anular_toma_inventario',
        data: sendData
      }).then(()=>{
          this.cargarTomasInventarioNueva();
          alert('La toma de inventario se anulo correctamente.')
          this.setState({tipo_toma_array_seleccionada:null,MuestraStock:true,observacion_toma:'', idTomaSeleccionada:null, tomaInventarioBusqueda:'', bodegasCreacion_sel:[]})
          this.props.cambiar_VisualizacionLoading(false);
      })
      .catch((err)=>{
          console.log(err)
          this.props.cambiar_VisualizacionLoading(false);
          alert('No se pudo procesar la transacción...');
      });
    }else{
      alert('Debe ingresar la toma que desea anular.')
    }
  }
  crearToma(){
    if(this.state.tipo_toma_array_seleccionada===null){
      alert('Seleccione un tipo de toma')
      return;
    }
    if(this.state.observacion_toma===''){
      alert('Ingrese una observacion')
      return;
    }
    if(this.state.bodegasCreacion_sel.length===0){
      alert('Debe seleccionar al menos una bodega')
    }
    let sendData={};
    let tomaId=null;
    if(this.state.idTomaSeleccionada!==null){
        tomaId=parseInt(this.state.idTomaSeleccionada,10)
    }else{
      tomaId=''
    }
    sendData.TipoToma= this.state.tipo_toma_array_seleccionada;
    sendData.Observacion= this.state.observacion_toma;
    sendData.MostrarStock = (this.state.MuestraStock)?'S':'N';
    sendData.Usuario= this.state.usuario;
    sendData.TomaInventarioId= tomaId;
    sendData.BodegasCreacion_sel = this.state.bodegasCreacion_sel
    this.props.cambiar_VisualizacionLoading(true);
    global_axios({
      method: 'POST',
      url: '/tomainventario/crear_toma_inventario',
      data: sendData
    }).then(()=>{
        this.cargarTomasInventarioNueva();
        alert('Se proceso la transacción.')
        this.setState({tipo_toma_array_seleccionada:null,MuestraStock:true,observacion_toma:'', idTomaSeleccionada:null, tomaInventarioBusqueda:'', bodegasCreacion_sel:[]})
        this.props.cambiar_VisualizacionLoading(false);
    })
    .catch((err)=>{
        console.log(err)
        this.props.cambiar_VisualizacionLoading(false);
        alert('No se pudo procesar la transacción...');
    });
  }
  actualizarColumnas (value){
    this.setState({articulos:[],articulosArrayAux:[],articulosTomaArrayCorte:[], verTodos:true})
    this.setState({toma_inventario_seleccionada: value!==null?value.value:null},()=>{
      this.cargarBodegasTomaInventario();
    });
    if(value===null){

      this.limpiar()
    }else{
      this.setState({tipo_toma:value.tipo_toma, muestra_stock: value.muestra_stock})
      if(value.muestra_stock==='S'){
        this.columnApi.setColumnsVisible(['Stock','Reserva'], true)
      }else{
        this.columnApi.setColumnsVisible(['Stock','Reserva'], false)
      }
    }
  }
  render(){        
        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Toma de Inventario</TituloForm>
            </HeaderForm>
            <CuerpoForm>
            <Row>
                <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                    <LabelForm>Toma Inventario:</LabelForm>
                    <ReactSelect options={ this.state.tomasInventario } value={this.state.toma_inventario_seleccionada} func_onChange={(value)=>{this.actualizarColumnas(value)}}/>
                </ContainerCol>
                
                <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                    <LabelForm>Bodega:</LabelForm>
                    <ReactSelect options={ this.state.bodega_opt } value={this.state.bodega_sel} func_onChange={(value)=>{this.cambiarBodega(value)}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                    <LabelForm>Línea:</LabelForm>
                    <ReactSelectAsync value={this.state.linea_seleccionada}  func_loadOptions={this.getOptions_TiposCompra} func_onChange={(value)=>{this.setState({linea_seleccionada: value!==null?value.value:null})}} /*func_onBlur={(value)=>{this.setCuenta(value)}}*//>
                </ContainerCol>
              </Row>
              <Row>
              <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                    <LabelForm>Artículo:</LabelForm>
                    <SelectArticulo  tipoArticulos={'P'} value={this.state.articulo_seleccionado}
                    func_onChange={(value)=>{this.setState({articulo_seleccionado: value!==null?value.value:null})}}/>
              </ContainerCol>
                <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                    <LabelForm >Nro. de parte:</LabelForm> 
                    <InputText name='numero_de_parte' value={this.state.numero_de_parte} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>            
                </ContainerCol> 
                <ContainerCol className='col-sm-2' margen_arriba='30' >
                    <div className='input-group'>
                        <span className='input-group-btn'>
                            <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.buscarStockArticulos}><i className='fa fa-search'></i> Buscar</ButtonUnion>                
                        </span>
                    </div>
                </ContainerCol> 
                <ContainerCol  className='col-sm-2' margen_arriba='30'>
                    <ToggleSwitch
                      checked={this.state.verTodos}
                      onChange={(event) => {this.verTodos(event)}}
                      size='sm'
                      />
                    <LabelTipoProf>Ver Todos</LabelTipoProf>
                </ContainerCol>
               
              </Row>
              <Row>
                <ContainerCol className='col-sm-2'>
                  <div className='btn-group'>                            
                      <button type='button' className='btn btn-link btn-xs'  onClick={this.detalleTomaInventario}><i className="fa fa-info" aria-hidden="true"/> Detalle Fila</button>  
                  </div>
                </ContainerCol>
                {
                  (this.state.isVisibleBotonCreacionToma)?
                  <ContainerCol className='col-sm-10'>
                    <div className='btn-group pull-right'>                            
                        <button type='button' className='btn btn-link btn-xs'  onClick={this.abrirModalTomaInventario}><i className="fa fa-file-o" aria-hidden="true"/> Creación Toma Inventario</button>  
                    </div>
                </ContainerCol>
                  :null
                }
               
              </Row>
              <Row>
              <div className='col-md-12'>   
                    <AgGridRender altura='200px'  alturaRow={30} data={this.state.articulos} columnas={this.state.columnDefs}
                    gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                </div>
                <div className="col-xs-12 col-sm-12">
                    <Row>
                        <ContainerCol className="col-xs-12 col-sm-12">
                            <PaginationLabels>
                                {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                            </PaginationLabels>
                            <PaginationButtons>
                                <div className="btn-group btn-group-xs" role="group">
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToFirstPage()}>
                                        <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToPreviousPage()}>
                                        <i className="fa fa-angle-left fa-fw"></i>Anterior
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToNextPage()}>
                                        Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToLastPage()}>
                                        Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                    </button>
                                </div>
                            </PaginationButtons>
                        </ContainerCol>
                    </Row>
                </div>
              </Row>
            </CuerpoForm>
            <ModalResponsive closeOut={true} open={this.state.isVisibleModalTomaInventario} onClose={() => this.setState({isVisibleModalTomaInventario:false, tipo_toma_array_seleccionada:null,MuestraStock:true,observacion_toma:'',tomaInventarioBusqueda:'',idTomaSeleccionada:null, puedeGuardar:true, bodegasCreacion_sel:[]})}>
              <ModalContainer>
                <Row>
                  <ContainerCol className='col-xs-12 col-sm-12' align="center">
                    <h4><strong>Creación de Toma de Inventario</strong></h4>
                    <Hr />
                  </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className="col-xs-12 col-sm-12">
                    <Row>
                      <ContainerCol className='col-sm-3'>
                        <LabelForm>Toma Inventario:</LabelForm>
                        <InputSearch tipoInput='text' nombre='tomaInventarioBusqueda' placeholder='No. Toma' valor={this.state.tomaInventarioBusqueda} func_CambiarValor={this.handleInputChange}
                          func_BuscarValor={this.getTomaById} func_OnFocus={()=>{this.setState({tipo_toma_array_seleccionada:null,MuestraStock:true,observacion_toma:'', idTomaSeleccionada:null, tomaInventarioBusqueda:'', puedeGuardar:true})}}/>
                      </ContainerCol>
                    </Row>
                    <Row>
                      <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                          <LabelForm>Tipo Toma Inventario:</LabelForm>
                          <ReactSelect disabled={!this.state.puedeGuardar} options={ this.state.TipoTomaArray } value={this.state.tipo_toma_array_seleccionada} func_onChange={(value)=>{this.setState({tipo_toma_array_seleccionada: value!==null?value.value:null});}}/>
                      </ContainerCol>
                      <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                          <LabelForm >Observación:</LabelForm> 
                          <InputText  disabled={!this.state.puedeGuardar} name='observacion_toma' value={this.state.observacion_toma} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>            
                      </ContainerCol> 
                      <ContainerCol  className='col-sm-3' margen_arriba='30'>
                        <ToggleSwitch
                          disabled={!this.state.puedeGuardar}
                          checked={this.state.MuestraStock}
                          onChange={(event) => {this.setState({ MuestraStock: !this.state.MuestraStock})}}
                          size='sm'
                          />
                        <LabelTipoProf>Muestra Stock</LabelTipoProf>
                    </ContainerCol>
                   </Row>
                   <Row>
                      <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                        <LabelForm>Lista Bodegas:</LabelForm>
                        <ReactMultiSelectCheckboxes  value={this.state.bodegasCreacion_sel} placeholderButtonLabel={'Seleccione Bodegas...'}  options={this.state.bodegasCreacion} onChange={(value)=>{this.setBodegasCreacion(value)}}/>
                      </ContainerCol>
                   </Row>
                   <Row>
                    <ContainerCol className='col-sm-12' margen_arriba='15' margen_abajo='4'>
                        <div className='btn-group pull-right'>                            
                          <button type='button'  className='btn btn-primary btn-sm'   onClick={this.crearToma}><i className="fa fa-save" aria-hidden="true"/> Guardar</button>  
                          <button type='button'  className='btn btn-danger btn-sm'  onClick={this.anularToma}><i className="fa fa-save" aria-hidden="true"/> Anular</button>  
                      </div>
                    </ContainerCol>
                   </Row>
                  </ContainerCol>
                </Row>
              </ModalContainer>
            </ModalResponsive>
            <ModalResponsive closeOut={true} open={this.state.isVisibleModalDetalleTomaInventario} onClose={() => this.setState({isVisibleModalDetalleTomaInventario:false})}>
              <ModalContainer>
                <Row>
                  <ContainerCol className='col-xs-12 col-sm-12' align="center">
                    <h4><strong>Detalle de Ingreso Toma</strong></h4>
                    <Hr />
                  </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className="col-xs-12 col-sm-12">
                    <div className='col-md-12'>   
                        <AgGridRender altura='120px'  alturaRow={20} data={this.state.detalleTomaInventario} columnas={this.state.columDTomaInventario}
                        gridOptions={this.gridDetalleTomaOptions} onGridReady={this.onGridDetalleTomaReady}/>
                    </div>
                    <div className="col-xs-12 col-sm-2 pull-right">
                      <LabelTotales>Total Cantidad: </LabelTotales> <LabelValorTotales>{this.state.totalDetalleToma}</LabelValorTotales>
                  </div>
                    <div className="col-xs-12 col-sm-12">
                        <Row>
                            <ContainerCol className="col-xs-12 col-sm-12">
                                <PaginationLabels>
                                    {this.state.paginationDetalleToma.primaraFilaPagina} a {this.state.paginationDetalleToma.ultimaFilaPagina} de {this.state.paginationDetalleToma.totalFilas}
                                </PaginationLabels>
                                <PaginationButtons>
                                    <div className="btn-group btn-group-xs" role="group">
                                        <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiDetalleToma.paginationGoToFirstPage()}>
                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                        </button>
                                        <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiDetalleToma.paginationGoToPreviousPage()}>
                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                        </button>
                                        <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiDetalleToma.paginationGoToNextPage()}>
                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                        </button>
                                        <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiDetalleToma.paginationGoToLastPage()}>
                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                        </button>
                                    </div>
                                </PaginationButtons>
                            </ContainerCol>
                        </Row>
                    </div>
                  </ContainerCol>
                </Row>
              </ModalContainer>
            </ModalResponsive>
          </ContenedorForm>
      );
  }
}

const mapStateToProps = ((state) => {
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            Usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit}
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormInven12);